// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"2643":"ee0b5224","4500":"ac1f3836","5590":"9eb181f4","6779":"e2c0db10"}[chunkId] + ".js";
};